"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unmask = exports.masks = exports["default"] = void 0;
/* eslint-disable */

var unmask = exports.unmask = function unmask(mask) {
  return mask.replace(/(\.)?(-)?([/])?/g, '');
};
var masks = exports.masks = {
  cpf: {
    mask: function mask(cpf) {
      var cpfSemFormatacao = cpf === null || cpf === void 0 ? void 0 : cpf.replace(/\D/g, '');
      if ((cpfSemFormatacao === null || cpfSemFormatacao === void 0 ? void 0 : cpfSemFormatacao.length) <= 14) {
        return cpfSemFormatacao.substr(0, 11).replace(/(\d{3})(\d)/, '$1.$2').replace(/(\d{3})(\d)/, '$1.$2').replace(/(\d{3})(\d{1,2})$/, '$1-$2');
      }
      return cpf === null || cpf === void 0 ? void 0 : cpf.substring(0, 11);
    },
    unmask: unmask
  },
  cnpj: {
    mask: function mask(cnpj) {
      var cnpjSemFormatacao = cnpj === null || cnpj === void 0 ? void 0 : cnpj.replace(/\D/g, '');
      if (cnpjSemFormatacao.length === 14) {
        return cnpjSemFormatacao.replace(/^(\d{2})(\d)/, '$1.$2').replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3').replace(/\.(\d{3})(\d)/, '.$1/$2').replace(/(\d{4})(\d)/, '$1-$2');
      }
      return cnpj === null || cnpj === void 0 ? void 0 : cnpj.substring(0, 14);
    },
    unmask: unmask
  },
  cpfCnpj: {
    mask: function mask(document) {
      if ((document === null || document === void 0 ? void 0 : document.length) <= 14) {
        return document.replace(/\D/g, '').replace(/(\d{3})(\d)/, '$1.$2').replace(/(\d{3})(\d)/, '$1.$2').replace(/(\d{3})(\d{1,2})$/, '$1-$2');
      }
      return document.replace(/\D/g, '').substring(0, 14).replace(/^(\d{2})(\d)/, '$1.$2').replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3').replace(/\.(\d{3})(\d)/, '.$1/$2').replace(/(\d{4})(\d)/, '$1-$2');
    },
    unmask: unmask
  },
  matriculaCef: {
    mask: function mask(matricula) {
      var matriculaUpperCase = matricula === null || matricula === void 0 ? void 0 : matricula.toUpperCase().replace(/[^\w\s]/gi, '');
      var onlyNumberRegex = /^[0-9]*$/;
      if (onlyNumberRegex.test(matriculaUpperCase) && (matriculaUpperCase === null || matriculaUpperCase === void 0 ? void 0 : matriculaUpperCase.length) == 6) {
        var matriculaFormatada = matriculaUpperCase.replace(/\D/g, '').substring(0, 6);
        return "C".concat(matriculaFormatada);
      }
      if (isMatriculaCef(matriculaUpperCase)) {
        return matriculaUpperCase.substring(0, 7);
      }
      return matriculaUpperCase;
    },
    unmask: unmask
  },
  rg: {
    mask: function mask(rg) {
      return rg.replace(/\D/g, '').replace(/(\d{2})(\d{3})(\d{3})(\d{1})$/, '$1.$2.$3-$4');
    },
    unmask: unmask
  },
  date: {
    mask: function mask(dateMask) {
      return dateMask === null || dateMask === void 0 ? void 0 : dateMask.replace(/\D/g, '').substring(0, 8).replace(/(\d{2})(\d)/, '$1/$2').replace(/(\d{2})(\d)/, '$1/$2');
    },
    unmask: function unmask(text) {
      return text;
    }
  },
  phone: {
    mask: function mask(phoneMask) {
      if (!phoneMask) {
        return '';
      }
      return phoneMask === null || phoneMask === void 0 ? void 0 : phoneMask.replace(/\D/g, '').replace(/^(\d)/, '($1').replace(/^(\(\d{2})(\d)/, '$1) $2').replace(/(\d{5})(\d{4})/, '$1-$2').replace(/(-\d{4})\d+?$/, '$1');
    },
    unmask: function unmask(text) {
      return masks.numberOnly.mask(text);
    }
  },
  name: {
    mask: function mask(value) {
      return value.replace(/\d/g, '');
    },
    unmask: unmask
  },
  homePhone: {
    mask: function mask(phoneMask) {
      if (!phoneMask) {
        return '';
      }
      return phoneMask === null || phoneMask === void 0 ? void 0 : phoneMask.replace(/\D/g, '').replace(/^(\d)/, '($1').replace(/^(\(\d{2})(\d)/, '$1) $2').replace(/(\d{4})(\d{4})/, '$1-$2').replace(/(-\d{4})\d+?$/, '$1');
    },
    unmask: function unmask(text) {
      return masks.numberOnly.mask(text);
    }
  },
  commercialPhone: {
    mask: function mask(phoneMask) {
      return phoneMask.replace(/\D/g, '').replace(/^(\d)/, '($1').replace(/^(\(\d{2})(\d)/, '$1) $2').replace(/(\d{4,5})(\d{4})/, '$1-$2').replace(/(-\d{4})\d+?$/, '$1');
    },
    unmask: function unmask(text) {
      return masks.numberOnly.mask(text);
    }
  },
  numberOnly: {
    mask: function mask(value) {
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
      if (!value) {
        return '';
      }
      return value.replace(/\D/g, '').substring(0, length);
    },
    unmask: function unmask(text) {
      return text.replace(/\D/g, '');
    }
  },
  agency: {
    mask: function mask(value) {
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 4;
      if (value === '') {
        return value;
      }
      return value.replace(/\D/g, '').substring(0, length);
    },
    unmask: unmask
  },
  agencyCode: {
    mask: function mask(value) {
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 4;
      if (value === '') {
        return value;
      }
      while (((_value = value) === null || _value === void 0 ? void 0 : _value.length) < length) {
        var _value;
        value = '0' + value;
      }
      return value;
    },
    unmask: unmask
  },
  year: {
    mask: function mask(value) {
      var _value2;
      if (value === '') {
        return value;
      }
      value = value.replace(/\D/g, '');
      if (((_value2 = value) === null || _value2 === void 0 ? void 0 : _value2.length) >= 2) {
        value = value.substring(0, 2);
      }
      return "".concat(value, " anos");
    },
    unmask: function unmask(value) {
      var onlyNumber = value.replace(/\D/g, '');
      if ((value === null || value === void 0 ? void 0 : value.length) > 3 && value.substring(2).trim() === 'ano') {
        return onlyNumber.substring(0, (onlyNumber === null || onlyNumber === void 0 ? void 0 : onlyNumber.length) - 1);
      }
      return onlyNumber.substring(0, 2);
    }
  },
  currency: {
    mask: function mask() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      if (typeof value === 'string') {
        return masks.currencyInput.mask(value);
      }
      if (!Number.isNaN(value) && Number.isFinite(value)) {
        var finalValue = value === null || value === void 0 ? void 0 : value.toFixed(2).replace('.', ',').replace(/\d(?=(\d{3})+,)/g, '$&.');
        return "R$ ".concat(finalValue);
      }
      return '';
    },
    unmask: function unmask(mask) {
      return mask === null || mask === void 0 ? void 0 : mask.replace(/\D/g, '');
    }
  },
  currencyInput: {
    mask: function mask(value) {
      var newValue = "".concat(value).replace(/\R\$/g, '');
      newValue = newValue.replace(',', '').split('.').join('');
      var valueParsed = parseFloat(newValue);
      return newValue === '' ? '' : masks.currency.mask(valueParsed / 100);
    },
    unmask: function unmask(mask) {
      return mask === null || mask === void 0 ? void 0 : mask.replace(/\D/g, '');
    }
  },
  none: {
    mask: function mask(text) {
      return text;
    },
    unmask: function unmask(text) {
      return text;
    }
  },
  cep: {
    mask: function mask(cep) {
      if (!cep) {
        return '';
      }
      return cep.replace(/\D/g, '').replace(/(.{8})(.)/g, '$1').replace(/^(\d{5})(\d)/, '$1-$2');
    },
    unmask: unmask
  },
  address: {
    mask: function mask(value) {
      return value.replace(/\$|\@|\%|\#|\!|\&|\*|\(|\)|\>|\<|\?|\/|\|\;|\:/g, '').substring(0, 50);
    },
    unmask: unmask
  },
  number: {
    mask: function mask(value) {
      if (!value) {
        return '';
      }
      return value.replace(/\D/g, '').substring(0, 15);
    },
    unmask: function unmask(value) {
      return masks.numberOnly.mask(value);
    }
  },
  complement: {
    mask: function mask(value) {
      return value.replace(/\$|\@|\%|\#|\!|\&|\*|\(|\)|\>|\<|\?|\/|\|\;|\:\¨\¨¨/g, '').substring(0, 100);
    },
    unmask: unmask
  },
  neighborhood: {
    mask: function mask(value) {
      return value.replace(/\$|\@|\%|\#|\!|\&|\*|\(|\)|\>|\<|\?|\/|\|\;|\:\¨\¨¨/g, '').substring(0, 30);
    },
    unmask: unmask
  },
  city: {
    mask: function mask(value) {
      return value.replace(/\$|\@|\%|\#|\!|\&|\*|\(|\)|\>|\<|\?|\/|\|\;|\:\¨\¨¨/g, '').substring(0, 35);
    },
    unmask: unmask
  },
  uf: {
    mask: function mask(value) {
      return value.replace(/\d|\$|\@|\%|\#|\!|\&|\*|\(|\)/g, '').substring(0, 2);
    },
    unmask: unmask
  },
  percentage: {
    mask: function mask(value) {
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;
      if (parseFloat(value) > 100) {
        return '100';
      }
      if (!value) {
        return '';
      }
      return value.replace(/\D/g, '').substring(0, length);
    },
    unmask: function unmask(text) {
      return text.replace(/\D/g, '');
    }
  },
  tokenOtp: {
    mask: function mask(value) {
      return value.substring(0, 9).replace(/\D/g, '').replace(/^(\d{3})(\d{3})(\d{3})/, '$1-$2-$3');
    },
    unmask: unmask
  },
  bankAccount: {
    mask: function mask(valueAccount) {
      var lengthAccount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 13;
      if (!valueAccount) {
        return '';
      }
      return valueAccount.replace(/\D/g, '').substring(0, lengthAccount);
    },
    unmask: function unmask(text) {
      return text.replace(/\D/g, '');
    }
  },
  dataBankDigits: {
    mask: function mask(value) {
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      if (!value) {
        return '';
      }
      return value.replace(/\$|\@|\%|\#|\!|\&|\*|\(|\)|\>|\<|\?|\/|\|\;|\:\¨\¨¨/g, '').substring(0, length);
    },
    unmask: function unmask(text) {
      return text.replace(/\$|\@|\%|\#|\!|\&|\*|\(|\)|\>|\<|\?|\/|\|\;|\:\¨\¨¨/g, '');
    }
  },
  removeSpaces: {
    mask: function mask(value) {
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      if (!value) {
        return '';
      }
      return value.replace(/\s/g, '');
    },
    unmask: function unmask(text) {
      return text;
    }
  },
  removeAcentos: {
    mask: function mask(value) {
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      if (!value) {
        return '';
      }
      return value.replace('Ã¡', 'á').replace('Ã©', 'é').replace('Ã¡', 'á');
    },
    unmask: function unmask(text) {
      return text;
    }
  }
};
var _default = exports["default"] = masks;